import React, { useEffect, useImperativeHandle, useState, forwardRef } from "react";
import { useFormik } from "formik";
import { InputBox, Password } from "../../../components/CustomWidgets/InputBox";
import { useTranslation } from "react-i18next";
import "../../../styles.css";
import { Image, Input } from "antd";
import FlagIcon from "../../../assets/egypt.svg";
import { subStoreBasicDetailSchema } from "../../../components/validationSchema";

const SubStoreBasicDetails = forwardRef(({ defaultData = {}, isEdit, onChange }, ref) => {
    const { t } = useTranslation();
    const [selectedCategories, setSelectedCategories] = useState([]);

    console.log("DEFAUILT DTA A BASIC,", defaultData);


    const formik = useFormik({
        initialValues: {
            emailid: defaultData?.emailid ?? "",
            phone: defaultData?.phone ?? "",
            branch_name: defaultData?.branch_name ?? "",
            password: defaultData?.password ?? "",
            confirmPassword: "",
        },
        validationSchema: subStoreBasicDetailSchema,
        validateOnMount: true,
        onSubmit: () => { },
    });


    useEffect(() => {
        if (isEdit && defaultData) {
            formik.setValues({
                emailid: defaultData?.email ?? "",
                phone: defaultData?.phone ?? "",
                branch_name: defaultData?.branch_name ?? "",
                password: defaultData?.password ?? "",
                confirmPassword: defaultData?.password ?? "",
            });
            formik.validateForm();
        }
    }, [isEdit, defaultData]);


    useImperativeHandle(ref, () => ({
        getData: () => {
            const data = {
                email: formik.values.emailid,
                phone: formik.values.phone,
                password: formik.values.password,
                branch_name: formik.values.branch_name,
                categories_ids: selectedCategories,
            };
            return formik.isValid ? data : null;
        },
        resetForm: formik.resetForm,
    }));

    useEffect(() => {
        if (isEdit && defaultData) {
            onChange?.(formik.isValid ? formik.values : null);
        }
    }, [formik.values, formik.isValid, isEdit, defaultData]);

    return (
        <div className="max-h-screen overflow-y-auto px-4 py-0 scrollbar-none pb-4">
            <h1 className="text-xl font-bold mb-2">{t("basic_details")}</h1>

            <form onSubmit={formik.handleSubmit}>
                <div className="grid grid-cols-1 gap-0">
                    {/* Row 1: Sub-Store Name */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8">
                        <InputBox
                            label={t("Branch Name")}
                            name="branch_name"
                            placeholder={t("Enter Branch Name")}
                            maxLength={50}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.branch_name}
                            error={formik.errors.branch_name}
                            touched={formik.touched.branch_name}
                        />
                    </div>
                    {formik.touched.branch_name && formik.errors.branch_name && (
                        <div className="text-red text-xs mt-1">{t(formik.errors.branch_name)}</div>
                    )}

                    {/* Row 2: Phone and Email */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8">
                        <div className="flex flex-col mt-2">
                            <label className="py-2 text-sm text-gray-600 font-medium">
                                {t("phone_number")}
                            </label>
                            <div className="flex items-center">
                                <div className="h-10 w-16 text-md text-body outline-none focus:outline-none rounded-lg border p-3 flex items-center justify-center bg-[#EBEBEB]">
                                    <Image src={FlagIcon} alt="img" />
                                </div>
                                <Input
                                    name="phone"
                                    value={formik.values.phone}
                                    placeholder={t("Enter Phone Number")}
                                    // onChange={formik.handleChange}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/\D/g, ""); // remove non-digits
                                        const startsWithZero = val.startsWith("0");
                                        const maxLength = startsWithZero ? 11 : 10;

                                        if (val.length <= maxLength) {
                                            formik.setFieldValue("phone", val);
                                        }
                                    }}
                                    onBlur={formik.handleBlur}
                                    maxLength={15}
                                    className={`h-10 ms-2 text-md text-body outline-none focus:outline-none ltr:pl-5 rtl:pr-5 rounded-md p-3 ${formik.touched.phone && formik.errors.phone ? "border-red" : ""
                                        }`}
                                />
                            </div>
                            {formik.touched.phone && formik.errors.phone && (
                                <div className="text-red text-xs mt-1">{t(formik.errors.phone)}</div>
                            )}
                        </div>
                        <div className="flex flex-col">
                            <InputBox
                                label={t("email")}
                                name="emailid"
                                placeholder={t("enter_email")}
                                maxLength={50}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.emailid}
                                error={formik.errors.emailid}
                                touched={formik.touched.emailid}
                                autoComplete="new-email"
                            />
                            {formik.touched.emailid && formik.errors.emailid && (
                                <div className="text-red text-xs mt-1">{t(formik.errors.emailid)}</div>
                            )}
                        </div>
                    </div>

                    {/* Row 3: Password and Confirm Password */}

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8">
                        {/* Password */}
                        <div className="flex flex-col mb-14">
                            <Password
                                label={t("Password")}
                                name="password"
                                placeholder={t("Enter Password")}
                                maxLength={20}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.password}
                                error={formik.errors.password}
                                touched={formik.touched.password}
                                autoComplete="new-password"
                            />
                            {formik.touched.password && formik.errors.password && (
                                <div className="text-red text-xs mt-1">{t(formik.errors.password)}</div> // ✅ Ensure visible spacing
                            )}
                        </div>

                        {/* Confirm Password */}
                        <div className="flex flex-col mb-14">
                            <Password
                                label={t("confirm_password")}
                                name="confirmPassword"
                                placeholder={t("Re-Enter Password")}
                                maxLength={20}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.confirmPassword}
                                error={formik.errors.confirmPassword}
                                touched={formik.touched.confirmPassword}
                                autoComplete="new-password"
                            />
                            {formik.touched.confirmPassword && formik.errors.confirmPassword && (
                                <div className="text-red text-xs mt-1">{t(formik.errors.confirmPassword)}</div>
                            )}
                        </div>
                    </div>
                </div>
            </form >
        </div >
    );
});

export default SubStoreBasicDetails;
